import { subjectPhotoGradient } from "Components/WebsiteTheme/subjectPhoto.style";
import styled from "styled-components";
import { C, MQ } from "Components/WebsiteTheme/WebsiteTheme.style";

/*
 * One section per subject, in the Home and About page style: sections alternate white and tint,
 * screenshot panel and copy side by side (alternating sides), game cards as white rounded cards.
 */
export const SubjectsOverviewContainer = styled.div`
	.so_subject {
		scroll-margin-top: 24px;
	}

	.so_row {
		display: grid;
		grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
		align-items: center;
		gap: 56px;

		${MQ.STACK} {
			gap: 40px;
		}

		${MQ.TABLET} {
			grid-template-columns: 1fr;
			gap: 28px;
		}
	}

	/* Image on the right for every second subject (desktop only) */
	.so_row--reverse .so_media {
		order: 2;

		${MQ.TABLET} {
			order: 0;
		}
	}

	.so_media {
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 24px;
		border: 1px solid ${C.line};
		border-radius: 20px;
		background: #fff;

		img {
			width: 100%;
			max-width: 600px;
			height: auto;
		}

		${MQ.PHONE} {
			padding: 14px;
			border-radius: 16px;
		}
	}

	/* On white sections the panel sits on the tint instead */
	.so_subject:not(.sm_section--tint) .so_media {
		background: ${C.tint};
	}

	.so_copy {
		display: flex;
		flex-direction: column;
		gap: 16px;

		${MQ.TABLET} {
			order: -1;
		}
	}

	.so_title_row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 16px;
	}

	.so_logo {
		position: relative;
		overflow: hidden;
		${subjectPhotoGradient}

		img {
			display: block;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		width: 110px;
		height: auto;
		aspect-ratio: 640 / 626;
		flex-shrink: 0;
		border-radius: 12px;
		object-fit: contain;

		${MQ.PHONE} {
			width: 88px;
			height: auto;
		}
	}

	/* Key words in the Civics text */
	.so_description .red-text {
		color: ${C.blue};
		font-weight: 700;
	}

	.so_cards {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 20px;
		margin-top: 48px;

		&.so_cards--two {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		${MQ.STACK} {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		${MQ.SMALL} {
			grid-template-columns: 1fr;

			&.so_cards--two {
				grid-template-columns: 1fr;
			}
		}

		${MQ.TABLET} {
			margin-top: 32px;
		}
	}

	.so_card {
		display: flex;
		align-items: center;
		gap: 18px;
		padding: 18px;
		box-shadow: ${C.cardShadow};
	}

	.so_card_icon {
		display: inline-flex;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		width: 76px;
		height: 92px;
		padding: 6px;
		border: 1px solid ${C.line};
		border-radius: 12px;
		background: #fff;

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}
`;
